const ProformaAPIURL = {

    //#region Proforma
    GetProforma: 'api/Proforma/GetProforma',
    GetProformaById: 'api/Proforma/GetProformaById',
    AddUpdateProforma: 'api/Proforma/AddUpdateProforma',
    DeleteProforma: 'api/Proforma/DeleteProforma',
    GetProformaPDF: 'api/Proforma/GetProformaPDF',
    GetProformaDoc: 'api/Proforma/GetProformaDoc',
    //#endregion

    //#region ROE
    GetRoe: 'api/Proforma/GetRoe',
    AddRoe: 'api/Proforma/AddRoe',
    //#endregion

}
export default ProformaAPIURL;